export default "__VITE_ASSET__43050cad__"